import React, { Component, Fragment } from 'react';
import moment from  'moment';
import { getLoginCatererInfo } from '../../../../server/utilCaterer';

const userInfo=getLoginCatererInfo();
const dateFormat=(userInfo['dateFormat']||'MM/DD/YYYY').toUpperCase();
class CalenderCarousel extends Component {
    constructor(props){
        super(props);
        this.state = {
            Week:  this.props.startDate.startOf('Week').format(dateFormat)+' - '+this.props.endDate.endOf('Week').format(dateFormat),
            startDate:this.props.startDate,
            endDate:this.props.endDate,
            Day: moment().format(dateFormat),
            Month: moment().format('MMMM YYYY'),
            date: this.props.date
        }
    }
    componentWillReceiveProps=(nextProps)=>{
        this.setState({ 
            Week: nextProps.startDate.startOf('Week').format(dateFormat)+' - '+nextProps.endDate.endOf('Week').format(dateFormat), 
            date: moment(nextProps.date),
            Day: moment(nextProps.date).format(dateFormat),
            Month:moment(nextProps.date).format('MMMM YYYY'),
            startDate:nextProps.startDate,
            endDate:nextProps.endDate 
        });
    }
    onDateChange=(start,end,cDate)=>{
        this.props.dateChange({start, end, cDate})
    }


    change = (action) => {
        console.log('action', action);
        switch (action) {
            case 'nextWeek': {
                let sdate = moment(this.state.date).endOf('Week').add(1, 'days');
                let edate = moment(this.state.date).endOf('Week').add(1, 'days');
                let from_date = sdate.startOf('Week');
                let to_date = edate.endOf('Week');
                console.log({ from_date: from_date, to_date: to_date });
                this.setState({ Week: from_date.format(dateFormat) + " - " + to_date.format(dateFormat), 
                date: new Date(sdate),
                startDate:from_date,
                endDate:to_date,
             },this.onDateChange(from_date,to_date,sdate));
                break;
            }
            case 'prevWeek': {
                let sdate = moment(this.state.date).startOf('Week').subtract(1, 'days');
                let edate = moment(this.state.date).startOf('Week').subtract(1, 'days');
                let from_date = sdate.startOf('Week');
                let to_date = edate.endOf('Week');
                console.log({ from_date: from_date, to_date: to_date });
                this.setState({ Week: from_date.format(dateFormat) + " - " + to_date.format(dateFormat), 
                date: moment(sdate),
                startDate:from_date,
                endDate:to_date },this.onDateChange(from_date,to_date, sdate));
                break;
            }
            case 'nextMonth': {
                let sMonth = moment(this.state.date).add(1, 'month');
                let eMonth = moment(this.state.date).add(1, 'month');
                this.setState({ Month: sMonth.format('MMMM YYYY'), 
                date: moment(sMonth),
                startDate:moment(sMonth).startOf('month'),
                endDate:moment(eMonth).endOf('month')
            },()=>{
                this.onDateChange(moment(sMonth).startOf('month'),moment(eMonth).endOf('month'),sMonth)
            });
                break;
            }
            case 'prevMonth': {
                let sMonth = moment(this.state.date).subtract(1, 'month');
                let eMonth = moment(this.state.date).subtract(1, 'month');
                this.setState({ Month: sMonth.format('MMMM YYYY'), date: moment(sMonth),
                startDate:moment(sMonth).startOf('month'),
                endDate:moment(eMonth).endOf('month') },
               ()=>{ 
                   this.onDateChange(moment(sMonth).startOf('month'),moment(eMonth).endOf('month'),sMonth);
                });
                break;
            }
            case 'nextDay': {
                // let nextDay = moment(this.state.date).add(1, 'days');
                // this.setState({ Day: nextDay.format('MM/DD/YYYY'), date: new Date(nextDay) },
                // this.onDateChange(nextDay,nextDay,nextDay));

                let sDay = moment(this.state.date).add(1, 'days');
                let eDay = moment(this.state.date).add(1, 'days');
                this.setState({ Day: sDay.format(dateFormat), 
                date: moment(sDay),
                startDate:moment(sDay).startOf('day'),
                endDate:moment(eDay).endOf('day')
            },()=>{
                this.onDateChange(moment(sDay).startOf('day'),moment(eDay).endOf('day'),sDay)
            });
                break;
            }
            case 'prevDay': {
                // let prevDay = moment(this.state.date).subtract(1, 'days');
                // this.setState({ Day: prevDay.format('MM/DD/YYYY'), date: new Date(prevDay) },
                // this.onDateChange(prevDay,prevDay,prevDay));

                let sDay = moment(this.state.date).subtract(1, 'days');
                let eDay = moment(this.state.date).subtract(1, 'days');
                this.setState({ Day: sDay.format(dateFormat), 
                date: moment(sDay),
                startDate:moment(sDay).startOf('day'),
                endDate:moment(eDay).endOf('day')
            },()=>{
                this.onDateChange(moment(sDay).startOf('day'),moment(eDay).endOf('day'),sDay)
            });
                break;
            }
        }
    }

    render() {
        let { Day, Month, Week } = this.state;
        let { type } = this.props;
        console.log('state', this.state);
        return (
            <Fragment>
               {type=='Day'&&<div>
                    <a style={{ fontSize: 'x-large' }} onClick={() => this.change("prev" + type)}><i className="fa fa-arrow-circle-left" aria-hidden="true"></i></a>
                    <lable style={{ fontSize: 'large', fontWeight: 700, padding: '25px' }}>{Day}</lable>
                    <a style={{ fontSize: 'x-large' }} onClick={() => this.change("next" + type)}><i className="fa fa-arrow-circle-right" aria-hidden="true"></i></a>
                </div>}
                {type=='Month'&&<div>
                    <a style={{ fontSize: 'x-large' }} onClick={() => this.change("prev" + type)}><i className="fa fa-arrow-circle-left" aria-hidden="true"></i></a>
                    <lable style={{ fontSize: 'large', fontWeight: 700, padding: '25px' }}>{Month}</lable>
                    <a style={{ fontSize: 'x-large' }} onClick={() => this.change("next" + type)}><i className="fa fa-arrow-circle-right" aria-hidden="true"></i></a>
                </div>}
                {type=='Week'&&<div>
                    <a style={{ fontSize: 'x-large' }} onClick={() => this.change("prev" + type)}><i className="fa fa-arrow-circle-left" aria-hidden="true"></i></a>
                    <lable style={{ fontSize: 'large', fontWeight: 700, padding: '25px' }}>{Week}</lable>
                    <a style={{ fontSize: 'x-large' }} onClick={() => this.change("next" + type)}><i className="fa fa-arrow-circle-right" aria-hidden="true"></i></a>
                </div>}
            </Fragment>
        );
    }
}

export default CalenderCarousel;


// WEBPACK FOOTER //
// ./src/components/Caterer/Orders/CalenderCarousel/CalenderCarousel.jsx